import { AST } from '@handlebars/parser';

import { NodeType } from '../../../node/types';

export const isPartialStatement = (statement: AST.Statement): statement is AST.PartialStatement =>
  statement.type === NodeType.PartialStatement;
